var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProductRecommendationsProvider',{ref:"provider",attrs:{"pageType":_vm.DY_PAGE_TYPES.cart,"selectorName":_vm.DY_API_CAMPAIGN_SELECTOR_NAMES.miniCartProductRecommendations},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var title = ref.title;
var items = ref.items;
var isLoading = ref.isLoading;
return [_c('ProductRecommendationsCardsSmall',_vm._b({attrs:{"context":_vm.$CONTEXTS.miniCart},on:{"select-size":_vm.onSelectSize}},'ProductRecommendationsCardsSmall',{ title: title, items: items, isLoading: isLoading },false))]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }